import type { CreateBosReactWrapper, WrappedRequest } from '@bos/api';
import { createBosReactWrapper } from '@bos/api';

import { useAppInfiniteQuery } from '../../lib/reactQuery/useAppInfiniteQuery';
import { useAppMutation } from '../../lib/reactQuery/useAppMutation/useAppMutation';
import { useAppQuery } from '../../lib/reactQuery/useAppQuery';

import { getAuthorization } from './getAuthorization';

type Autofill = { authorization: string };

const getAutofill = (): Autofill => ({
	authorization: getAuthorization(),
});

/** @public Knip ignore, used in generated files */
export const wrapper: ReturnType<typeof createBosReactWrapper<Autofill>> =
	createBosReactWrapper({
		getAutofill,
		getUseQuery: () => useAppQuery,
		getUseInfiniteQuery: () => useAppInfiniteQuery,
		getUseMutation: () => useAppMutation,
	});

export type Wrapper<
	TReq extends WrappedRequest<Autofill, any, any>,
	// eslint-disable-next-line @typescript-eslint/naming-convention, no-unused-vars
	_TOptions,
> = CreateBosReactWrapper<ReturnType<typeof getAutofill>, TReq>;
